document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const navigation = document.querySelector('.c-navigation');
  const headerMain = document.querySelector('.c-header__main');
  let activeSectionTimeout = null;
  let currentActiveSection = null;

  if (!navigation || !headerMain) return;

  document.addEventListener('click', (event) => {
    const { target } = event;

    if (target.matches('.js-toggleSiteSearch, .js-toggleSiteSearch *')) {
      const searchBarContainer = document.querySelector('.c-header__search .c-site-search--desktop');
      const searchIcon = target.closest('.js-toggleSiteSearch').querySelector('i');
      const searchBar = searchBarContainer.querySelector('.c-site-search__input');
      const searchSubmit = searchBarContainer.querySelector('.c-form__submit');
      if (searchBarContainer && searchIcon) {
        searchBarContainer.classList.toggle('is-active');
        searchIcon.classList.toggle('gg--search');
        searchIcon.classList.toggle('gg--close');
        if (searchBarContainer.classList.contains('is-active')) {
          searchBar.focus();
          searchBar.setAttribute("tabindex","0");
          searchSubmit.setAttribute("tabindex","0");
          if (target.matches('button')) {
            target.setAttribute('aria-expanded', 'true');
          }else{
            target.parentElement.parentElement.setAttribute('aria-expanded', 'true');
          }
        }else{
          searchBar.setAttribute("tabindex","-1");
          searchSubmit.setAttribute("tabindex","-1");
          if (target.matches('button')) {
            target.setAttribute('aria-expanded', 'false');
            target.blur();
          }else{
            target.parentElement.parentElement.setAttribute('aria-expanded', 'false');
            target.parentElement.parentElement.blur();
          }
        }
      }
    }

    if (target.matches('.c-hamburger__menu, .c-hamburger__menu *')) {
      event.preventDefault();
      toggleNavigation();
    }

    if (target.closest('.c-link__parent-mobile')) {
      closeDropdown(target);
    }

    if (!target.closest('.c-navigation, .c-hamburger__menu, .nav-dropdown, .nav-section')) {
      closeNavigationOnClickOutside();
    }

    if (target.closest('.mobile-nav-cta__link')) {
      target.closest('.mobile-nav-cta__link').querySelector('a').click();
    }

    if (currentActiveSection && !target.closest('.nav-section')) {
      deactivateCurrentSection();
    }
  });

  function deactivateCurrentSection() {
    if (!currentActiveSection) {
      return
    }

    currentActiveSection.classList.remove('is-active');
    toggleCalloutActive(currentActiveSection, false);

    const parentLink = currentActiveSection.querySelector('.c-link__parent');
    const dropdown = currentActiveSection.querySelector('.nav-dropdown');

    if (parentLink) {
      parentLink.classList.remove('is-active');
      const link = parentLink.querySelector('a');

      if (link) {
        link.setAttribute('aria-expanded', 'false');
      }
    }

    if (dropdown) {
      dropdown.classList.remove('is-active');
    }

    currentActiveSection = null;
  }

  function activateSection(section) {
    section.classList.add('is-active');
    toggleCalloutActive(section, true);

    const parentLink = section.querySelector('.c-link__parent');
    const dropdown = section.querySelector('.nav-dropdown');

    if (parentLink) {
      parentLink.classList.add('is-active');
      const link = parentLink.querySelector('a');

      if (link) {
        link.setAttribute('aria-expanded', 'true');
      }
    }

    if (dropdown) {
      dropdown.classList.add('is-active');
    }

    currentActiveSection = section;
  }

  document.querySelectorAll('.nav-section').forEach(section => {
    section.addEventListener('click', (event) => {
      if (event.target.closest('.nav-dropdown')) {
        return;
      }

      if (section.classList.contains('is-active')) {
        deactivateCurrentSection();
        return;
      }

      if (currentActiveSection) {
        deactivateCurrentSection();
      }

      activateSection(section);
    });

    section.querySelectorAll('.c-link__parent').forEach(parentLink => {
      parentLink.addEventListener('focus', () => {
        clearTimeout(activeSectionTimeout);

        if (currentActiveSection && currentActiveSection !== section) {
          deactivateCurrentSection();
        }

        activateSection(section);
      });

      parentLink.addEventListener('keydown', handleKeydown);
    });
  });

  window.addEventListener('resize', resetNavigationOnResize);

  function handleKeydown(event) {
    const { key } = event;
    const parentLink = event.target.closest('.c-link__parent');
    const dropdown = parentLink ? parentLink.nextElementSibling : null;
    switch (key) {
      case 'ArrowDown':
        event.preventDefault();
        if (dropdown && dropdown.classList.contains('is-active')) {
          dropdown.querySelector('a').focus();
          return;
        }

        const nextSibling = parentLink.parentElement.nextElementSibling;
        if (nextSibling) {
          nextSibling.querySelector('a').focus();
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        const previousSibling = parentLink.parentElement.previousElementSibling;
        if (previousSibling) {
          previousSibling.querySelector('a').focus();
        }
        break;
      case 'Escape':
        event.preventDefault();
        closeAllDropdowns();
        parentLink.querySelector('a').focus();
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        toggleDropdown(parentLink);
        break;
    }
  }

  function toggleNavigation() {
    const isOpen = navigation.classList.contains('is-open');
    navigation.classList.toggle('is-open');
    body.classList.toggle('nav-open');

    const hamburgerIcon = document.querySelector('.c-hamburger');
    hamburgerIcon && isOpen && hamburgerIcon.classList.remove('is-active');
    hamburgerIcon && !isOpen && hamburgerIcon.classList.add('is-active');

    const navDropDowns = document.querySelectorAll('.nav-dropdown.is-active');
    isOpen && navDropDowns.forEach(dropdown => dropdown.classList.toggle('is-active'));

    const hamburgerButton = document.querySelector('.c-hamburger__menu');
    hamburgerButton && hamburgerButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    const copyText = hamburgerButton.querySelector('.c-copy');
    copyText && (copyText.textContent = isOpen ? 'Menu' : 'Close');
  }

  function toggleDropdown(target) {
    const parentLink = target.closest('.c-link__parent');
    const dropdown = parentLink ? parentLink.nextElementSibling : null;
    if (!dropdown || !dropdown.classList.contains('nav-dropdown')) return;

    dropdown.classList.toggle('is-active');
    const mobileParentLink = dropdown.querySelector('.c-link__parent-mobile');
    if (dropdown.classList.contains('is-active') && mobileParentLink) {
      mobileParentLink.classList.add('is-sticky');
    } else if (mobileParentLink) {
      mobileParentLink.classList.remove('is-sticky');
    }
  }

  function closeDropdown(target) {
    const dropdown = target.closest('.nav-dropdown');
    if (!dropdown || !dropdown.classList.contains('is-active')) return;

    dropdown.classList.remove('is-active');
    target.classList.remove('is-sticky');
  }

  function closeNavigationOnClickOutside() {
    if (navigation.classList.contains('is-open')) {
      toggleNavigation();
      document.body.removeAttribute('style');
    }
  }

  function resetNavigationOnResize() {
    if (window.innerWidth < 1024) return;

    if (navigation.classList.contains('is-open')) {
      navigation.classList.remove('is-open');
      body.classList.remove('nav-open');
    }

    const hamburgerIcon = document.querySelector('.c-hamburger.js-mobileNavTarget');
    if (hamburgerIcon && hamburgerIcon.classList.contains('is-active')) {
      hamburgerIcon.classList.remove('is-active');
    }

    const hamburgerButton = document.querySelector('.c-hamburger__menu');
    if (hamburgerButton) {
      hamburgerButton.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('.nav-dropdown.is-active').forEach(dropdown => {
      dropdown.classList.remove('is-active');
    });

    const copyText = hamburgerButton.querySelector('.c-copy');
    if (copyText) {
      copyText.textContent = 'Open';
    }

    const searchBarContainer = document.querySelector('.c-header__search .c-site-search--desktop');
    const searchIcon = document.querySelector('.c-site-search__toggle i');
    if (searchBarContainer && searchBarContainer.classList.contains('is-active')) {
      searchBarContainer.classList.remove('is-active');
    }
    if (searchIcon && searchIcon.classList.contains('gg--close')) {
      searchIcon.classList.remove('gg--close');
      searchIcon.classList.add('gg--search');
    }
  }

  function initiateSlider(callout) {
    const slider = callout.querySelector('.nav-section__callout-images');
    if (!slider) return;
    const slides = slider.children;
    let index = 0;

    if (slides.length > 0) {
      slides[0].style.left = '0%';
      slides[0].style.zIndex = slides.length;
    }
    if (slides.length > 1) {
      slides[1].style.left = '100%';
    }

    function slideNext() {
      if (index < slides.length - 1) {
        slides[index].style.left = '-100%';

        const nextIndex = index + 1;
        slides[nextIndex].style.left = '0%';
        slides[nextIndex].style.zIndex = slides.length - index;

        index++;
      }
    }

    const interval = setInterval(function() {
      slideNext();

      if (index === slides.length - 1) {
        clearInterval(interval);
      }
    }, 1000);

    slider.dataset.intervalId = interval;
  }

  function toggleCalloutActive(section, isActive) {
    const callout = section.querySelector('.nav-section__callout');
    if (!callout) return;

    clearTimeout(callout.dataset.timeoutId);

    if (isActive) {
      const timeoutId = setTimeout(() => {
        callout.classList.add('is-active');
        if (!callout.querySelector('.nav-section__callout-images').dataset.intervalId) {
          initiateSlider(callout);
        }
      }, 500);
      callout.dataset.timeoutId = timeoutId;
    } else {
      callout.classList.remove('is-active');
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.nav-dropdown.is-active').forEach(dropdown => {
      dropdown.classList.remove('is-active');
      const parentLink = dropdown.previousElementSibling;
      parentLink && parentLink.classList.remove('is-active');
      parentLink && parentLink.querySelector('a') && parentLink.querySelector('a').setAttribute('aria-expanded', 'false');
    });
  }
});
